import { render, staticRenderFns } from "./view-footer-root.vue?vue&type=template&id=2bd9036e&scoped=true&"
import script from "./view-footer-root.vue?vue&type=script&lang=js&"
export * from "./view-footer-root.vue?vue&type=script&lang=js&"
import style0 from "./view-footer-root.vue?vue&type=style&index=0&id=2bd9036e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd9036e",
  null
  
)

export default component.exports